import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { ArrowRight, MapPin } from "lucide-react";
import { Input } from "@/components/ui/input";

export default function Hubs() {
  const [hubs, setHubs] = useState([]);
  const [q, setQ] = useState("");
  const nav = useNavigate();

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/hubs");
      setHubs(data);
    })();
  }, []);

  const filtered = hubs.filter(
    (h) =>
      h.city.toLowerCase().includes(q.toLowerCase()) ||
      h.name.toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div className="space-y-8" data-testid="hubs-page">
      <div>
        <div className="text-xs uppercase tracking-[0.22em] text-[#E8D6A3] mb-3">
          Discover
        </div>
        <h1 className="text-4xl md:text-5xl font-black tracking-tighter mb-2">
          Find your hub.
        </h1>
        <p className="text-zinc-400">
          Live availability across {hubs.length} Mirrorloops hubs.
        </p>
      </div>

      <Input
        placeholder="Search city or hub…"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        data-testid="hubs-search-input"
        className="bg-white/5 border-white/10 max-w-md"
      />

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {filtered.map((h) => (
          <button
            key={h.id}
            data-testid={`hub-card-${h.city.toLowerCase()}`}
            onClick={() => nav(`/app/hubs/${h.id}`)}
            className="text-left rounded-2xl border border-white/10 bg-white/[0.02] p-6 hover:bg-white/[0.04] hover:border-[#D4B878]/30 transition"
          >
            <div className="flex items-start justify-between">
              <div>
                <div className="text-xs uppercase tracking-[0.2em] text-[#E8D6A3] mb-2">
                  Format {h.format}
                </div>
                <div className="text-2xl font-bold">{h.name}</div>
                <div className="text-sm text-zinc-500 flex items-center gap-1 mt-1">
                  <MapPin size={12} /> {h.city}, {h.state}
                </div>
              </div>
              <div className="text-right">
                <div className="text-3xl font-black">{h.available_now}</div>
                <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500">
                  free / {h.total_capacity}
                </div>
              </div>
            </div>
            <div className="mt-6 pt-5 border-t border-white/5 flex items-center justify-between text-sm text-zinc-400">
              <span>{h.opening_hours}</span>
              <span className="text-[#E8D6A3] inline-flex items-center gap-1 font-semibold">
                Explore <ArrowRight size={14} />
              </span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
